import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: ''
    }
  },
  {
    title: true,
    name: 'Componentes'
  },

  {
    name: 'Medicina',
    url: '/clinicAdmins',
    icon: 'cil-power-standby',
    children: [
      {
        name: 'Historia Clinica',
        url: '/clinicAdmins/clinicHistory',
        icon: 'icon-user'
      },
            {
        name: 'Remisiones',
        url: '/clinicAdmins/remissions',
        icon: 'icon-user'
      },


      // {
      //   name: 'Pacientes',
      //   url: '/admins/patients/1',
      //   icon: 'icon-user'
      // },
      // {
      //   name: 'Futuros Pacientes',
      //   url: '/admins/patients/0',
      //   icon: 'icon-user'
      // }
    ]
  },
  {
    name: 'Odontología',
    url: '/dental-Admins',

    icon: 'cil-power-standby',
    children: [
      {
        name: 'Historia Odontológica',
        url: '/dental-Admins/dentalHistory',
        icon: 'icon-user'
      },
      {
        name: 'Odontogramas',
        url: '/dental-Admins/odontogramasHistory',
        icon: 'icon-user'
      },

      {
        name: 'Cotizaciones',
        url: '/dental-Admins/quotesHistory',
        icon: 'icon-user'
      },

    ]
  },

  {
    name: 'Pacientes',
    url: '/clinicAdmins',
    icon: 'cil-power-standby',
    children: [
      {
        name: 'Pacientes',
        url: '/admins/patients/1',
        icon: 'icon-user'
      },
      {
        name: 'Futuros Pacientes',
        url: '/admins/patients/0',
        icon: 'icon-user'
      }
    ]
  },

  // }
  {
    name: 'Reportes',
    url: '/reports',
    icon: 'icon-list',
    children: [
      {
        name: 'Reportes Medicina',
        url: 'reports/listAppointments',
        icon: 'icon-note'
      },

      {
        name: 'Procedimientos',
        url: 'reports/subServicesReports',
        icon: 'icon-note'
      },

      {
        name: 'Rep.Métodos Pago',
        url: 'reports/paytypereports',
        icon: 'icon-note'
      },

    ]
  },

  {
    name: 'Administración',
    url: '/admins',
    icon: 'cil-power-standby',
    children: [
      {
        name: 'Usuarios',
        url: '/admins/users',
        icon: 'icon-user'
      },
      {
        name: 'Sedes',
        url: '/admins/headQuarters',
        icon: 'icon-location-pin'
      },
      {
        name: 'Consultorios',
        url: '/admins/clinicalOffices',
        icon: 'icon-user'
      },
      {
        name: 'Personal',
        url: '/admins/employees',
        icon: 'icon-user',
        children: [

            {
              name: 'Activos',
              url: '/admins/employees',
              icon: 'icon-sun',
              linkProps: { queryParams: { 'filter': '01' } }
            },
            {
              name: 'Inactivos',
              url: '/admins/employees',
              icon: 'icon-x-circle',
              linkProps: { queryParams: { 'filter': '00' } }
            },

        ]
      },
      {
        name: 'Compañia',
        url: '/admins/company',
        icon: 'icon-user'
      },

      {
        name: 'Recibos',
        url: '/clinicAdmins/invoices',
        icon: 'icon-note'
      },

      {
        name: 'Política de Datos',
        url: '/admins/politica-datos',
        icon: 'icon-user'
      },

    ]
  },
];
